import React from 'react';
import PropTypes from 'prop-types';
import { FormLabel } from '@hopper/form_label';
import { FormInlineError } from '@hopper/form_inline_error';

var Label = function Label(_a) {
  var _b = _a.children,
    children = _b === void 0 ? null : _b,
    _c = _a.isOptional,
    isOptional = _c === void 0 ? false : _c;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children, !isOptional && /*#__PURE__*/React.createElement("span", {
    className: "text-danger"
  }, " *"));
};

var FormField = function FormField(_a) {
  var children = _a.children,
    label = _a.label,
    errorMessage = _a.errorMessage,
    _b = _a.isOptional,
    isOptional = _b === void 0 ? false : _b,
    description = _a.description;
  return /*#__PURE__*/React.createElement(FormLabel, null, label && /*#__PURE__*/React.createElement("div", {
    className: "text-sm mb-sm tw:font-bold"
  }, /*#__PURE__*/React.createElement(Label, {
    isOptional: isOptional
  }, label)), /*#__PURE__*/React.createElement("div", {
    className: "text-base"
  }, children), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "mt-sm"
  }, /*#__PURE__*/React.createElement(FormInlineError, null, errorMessage)), description && /*#__PURE__*/React.createElement("div", {
    className: "mt-sm text-xs text-secondary leading-125 tw:text-sm tw:text-tw-secondary-500 tw:leading-150"
  }, description));
};
FormField.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.node,
  errorMessage: PropTypes.node,
  isOptional: PropTypes.bool,
  description: PropTypes.node
};

export { FormField };
//# sourceMappingURL=index.es.js.map
